import flattenMessages from '../../../helpers/flattenMessages';

export default {
  en: flattenMessages({}, 'user-agreement'),
  ja: flattenMessages({}, 'user-agreement'),
};
